import {
  defineAbility,
} from '@casl/ability';
import {
  get,
  uniq,
} from 'lodash';

import { PERMISSIONS } from './../constants/Permissions';

const { ALPHA, BETA } = PERMISSIONS;

import PermissionsTypes from './../constants/PermissionsTypes';

const { CREATE, READ, UPDATE, DELETE } = PermissionsTypes;

const { ALPHA_FEATURES, BETA_FEATURES } = require('./../constants/features');

import {
  LICENSE_CONSTANTS,
} from '@/constants';

import {
  CONNECTOR,
  GLOBAL,
  INSIGHT,
  INTRANET,
  KAM,
  MARKETING,
  SALES,
  SALES_AUTOMATION,
  SALES_AUTOMATION_V2,
  SALES_AND_MARKETING,
  SALES_AND_MARKETING_V2,
  SALES_PME,
  SEARCH_AND_LISTS,
  SENDER,
  SMART_CAMPAIGN_V2,
  SMART_DATA,
  SENDER_V2,
} from '@/constants/abilities';

const capacities = {
  0: GLOBAL,
  [LICENSE_CONSTANTS.SALES.ID]: SALES,
  [LICENSE_CONSTANTS.MARKETING.ID]: MARKETING,
  [LICENSE_CONSTANTS.SALES_AND_MARKETING.ID]: SALES_AND_MARKETING,
  [LICENSE_CONSTANTS.SALES_AND_MARKETING_V2.ID]: SALES_AND_MARKETING_V2,
  [LICENSE_CONSTANTS.INTRANET.ID]: INTRANET,
  [LICENSE_CONSTANTS.KAM.ID]: KAM,
  [LICENSE_CONSTANTS.CONNECTOR.ID]: CONNECTOR,
  [LICENSE_CONSTANTS.SEARCH_AND_LISTS.ID]: SEARCH_AND_LISTS,
  [LICENSE_CONSTANTS.SALES_PME.ID]: SALES_PME,
  [LICENSE_CONSTANTS.INSIGHT.ID]: INSIGHT,
  [LICENSE_CONSTANTS.SENDER.ID]: SENDER,
  [LICENSE_CONSTANTS.SALES_AUTOMATION.ID]: SALES_AUTOMATION,
  [LICENSE_CONSTANTS.SMART_DATA.ID]: SMART_DATA,
  [LICENSE_CONSTANTS.SALES_AUTOMATION_V2.ID]: SALES_AUTOMATION_V2,
  [LICENSE_CONSTANTS.SMART_CAMPAIGN_V2.ID]: SMART_CAMPAIGN_V2,
  [LICENSE_CONSTANTS.SENDER_V2.ID]: SENDER_V2,
};

const getCapacities = (capacity_list, user_tester_level) => {
  const uniq_capacity_list = {};

  if (user_tester_level) {
    if (user_tester_level === 'Alpha') {
      uniq_capacity_list[ALPHA] = [CREATE, READ, UPDATE, DELETE];
      uniq_capacity_list[BETA] = [CREATE, READ, UPDATE, DELETE];
    }

    if (user_tester_level === 'Beta') {
      uniq_capacity_list[BETA] = [CREATE, READ, UPDATE, DELETE];
    }
  }

  capacity_list.can.forEach((capacity) => {
    if (ALPHA_FEATURES[capacity.element] && !uniq_capacity_list[ALPHA]) {
      return;
    }

    if (
      BETA_FEATURES[capacity.element]
      && !uniq_capacity_list[BETA]
      && !uniq_capacity_list[ALPHA]
    ) {
      return;
    }

    uniq_capacity_list[capacity.element] = uniq_capacity_list[capacity.element]
      ? uniq(uniq_capacity_list[capacity.element].concat(capacity.action_list))
      : capacity.action_list;
  });

  return (can) => {
    Object
      .entries(uniq_capacity_list)
      .forEach(([element, action_list]) => {
        can(action_list, element);
      });
  };
};

export default function defineAbilitiesFor(user) {
  const license_id = get(user, 'organization_user_license_list[0].license.id', 0);
  const user_tester_level = get(user, 'tester_level', null);

  return defineAbility(getCapacities(capacities[license_id], user_tester_level));
}
